<template>
  <el-container>
    <el-header>
      <admin-header></admin-header>
    </el-header>
    <nav-menu-left></nav-menu-left>
    <div style="padding-left: 220px; margin-top: 70px;">
      <keep-alive :include="include">
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
  </el-container>
</template>

<script>
import AdminHeader from "@/components/AdminHeader"
import NavMenuLeft from "@/components/NavMenuLeft"
export default {
  components: {
    "admin-header": AdminHeader,
    "nav-menu-left": NavMenuLeft
  },
  data() {
    return {
      //缓存名称
      include: []
    }
  },
  watch: {
    //监听路由去判断是否为缓存页面
    $route(to, from) {
        console.log(this.include)
        console.log(to)
        console.log(from)
      if(this.$route.meta.keepAlive){
        !this.include.includes(to.name) && this.include.push(to.name)
      }
      //初始化页面就判断是否需要缓存，需要的话就push进include  否则会初始化跳转其他页面 再跳转回来会失效
      //添加缓存（列表跳去详情）
      if(to.meta.keepAlive){
        //先判断是否已经包含需要缓存的路由名称 不包含才追加 否则不追加
        // 例如:["memberAuditList"]  已经包含了,则不需要添加
        !this.include.includes(to.name) && this.include.push(to.name)
      }
      if (from.meta.keepAlive && to.meta.level <= from.meta.level) {
        console.log('缓存页跳到缓存页 清除缓存 to.meta.level < from.meta.level')
        let index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
      if (!to.meta.keepAlive && to.meta.level <= from.meta.level) {
        console.log('缓存页跳到缓存页 清除缓存 to.meta.level < from.meta.level')
        let index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      //如果 要 form(离开) 的页面是 keepAlive缓存的，
      //再根据 level 来判断是前进还是后退
      //如果是后退
      /**
       * level 列表详情页设置为2
       * 列表页设置为1
       * 其他不需要缓存路由设置为undefined  就是不用设置
       *
       */
      //undefined代表其他路由 1代表列表需缓存 2代表详情
      //清空缓存（其他路由跳去列表） 通过自定义level层级大小判断 2 <= 1?
      //例如，当前from是需要缓存的列表，level是1，如果点了非详情路由 to，则level是undefined或者0，那么就要清除
      //反之，当前from是需要缓存的列表，level是1，如果点了详情路由 to，则level是2，那么就不清除
      //  if (from.meta.keepAlive && from.meta.level >= to.meta.level) {
    }
  }
}
</script>

<style scoped lang="less">
html,
body {
  width: 1300px;
  background: #e7e7e7;
}
.el-header {
  position: fixed;
  width: 100%;
  top: 0;
  background: #fff;
  border-bottom: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/admin-index/Index.vue